import BaseButton from "../components/BaseButton/BaseButton";
import {useDispatch, useSelector} from 'react-redux'
import Modal from "../components/Modal/modal";
import useModal from "../components/Modal/useModal";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from 'react';
import {InvoiceInputList, InvoiceAdditionalInputList} from "../constants/InputItem";
import {buttonTheme} from "../components/BaseButton/buttonTheme";
import {getInvoice, createInvoice, updateInvoice, deleteInvoice} from "../services/invoice";
import Loading from "../components/Loading/Loading";
import {setInvoiceData, clearForm} from "../store/slices/invoiceSlice";
import {invoiceInfoInterface} from "../services/dataInterface";


function InfoItem({label, content}) {
    return (<div className={'py-4 border-b border-slate-100'}>
        <div className={'flex justify-between items-center flex-wrap'}>
            <div className={'font-semibold flex-1 mb-2 min-w-fit'}>{label}</div>
            <div>{content}</div>
        </div>
    </div>)
}

function AdditionalOption({formData}) {
    return (<div>
        {InvoiceAdditionalInputList.map(item => (<div key={item.id}>
            {formData[item.id]}
            {formData[item.id] ? item.label : ''}
        </div>))}
    </div>)
}

function AhamoveIdList({parentId, childIdList}) {
    const limit = 5
    let childString = ''
    if (childIdList && childIdList.length > 0) {
        const filteredChildIdList = childIdList.slice(0, limit)
        const reducer = (previousValue, currentValue) => {
            return previousValue + ', ' + currentValue
        };
        childString = filteredChildIdList.reduce(reducer)
        if (childIdList.length >= limit) {
            childString += ' ...'
        }
    }
    return (<div>{childString}</div>)
}

function InformationList({inputList, formData}) {
    const listItems = inputList.map(({label, id}) => (<InfoItem label={label} key={id} content={formData[id]}/>));
    return (<div>
        {listItems}
    </div>);
}

function ConfirmFooter({openConfirm}) {
    return (<div className={'mb-24'}>
        <div className={'drop-shadow sm:drop-shadow-none fixed bottom-0 w-full sm:static sm:p-0 bg-white'}>
            <div className={'p-2'}>
                <BaseButton buttonStyle={buttonTheme.confirm}
                            onClick={openConfirm}
                            label={'Gửi yêu cầu xuất hóa đơn'}/>
            </div>
        </div>
    </div>)
}

function CompletedFooter({openDelete}) {
    const navigate = useNavigate();
    return (<div className={'px-3 mb-5'}>
        <BaseButton buttonStyle={buttonTheme.cancel}
                    onClick={() => navigate('/?status=modify')}
                    label={'Chỉnh sửa thông tin'}/>
        <BaseButton buttonStyle={buttonTheme.cancelEmpty}
                    onClick={openDelete}
                    label={'Xóa đăng ký hóa đơn'}/>
    </div>)
}

function ConfirmModal({cancel, submit}) {
    return (<div className={'flex flex-col w-full p-2 px-4'}>
        <div className={'font-medium text-lg mb-2'}>
            Lưu ý khi thay đổi thông tin
        </div>
        <div className={'text-gray-400 mb-2'}>
            Thông tin sẽ không được thay đổi sau ngày 3 hàng tháng. Thay đổi của bạn sẽ được tính cho hỗ trợ vào
            tháng
            kế tiếp
        </div>
        <div className={'flex justify-between items-center'}>
            <div className={'w-full pr-1'}>
                <BaseButton buttonStyle={buttonTheme.cancel}
                            onClick={cancel}
                            label={'Quay lại'}/>

            </div>
            <div className={'w-full pl-1'}>
                <BaseButton buttonStyle={buttonTheme.confirm}
                            onClick={submit}
                            label={'Xác nhận thay đổi'}/>
            </div>
        </div>
    </div>)
}

function DeleteModal({cancel, deleteInvoice}) {
    return (<div className={'flex flex-col w-full p-2 px-4'}>
        <div className={'font-medium text-lg mb-2'}>
            Xóa đăng ký hóa đơn
        </div>
        <div className={'text-gray-400 mb-2'}>
            Bạn có muốn xóa đăng ký hóa đơn
        </div>
        <div className={'flex justify-between items-center'}>
            <div className={'w-full pr-1'}>
                <BaseButton buttonStyle={buttonTheme.cancel}
                            onClick={cancel}
                            label={'Không xoá'}/>

            </div>
            <div className={'w-full pl-1'}>
                <BaseButton buttonStyle={buttonTheme.remove}
                            onClick={deleteInvoice}
                            label={'Xoá'}/>
            </div>
        </div>
    </div>)
}

function InformationHeader({invoiceStatus}) {
    return (
        <div className={'sm:hidden flex flex-col p-3 w-full'}>
            <div className={'flex w-full'}>
                <div className={'w-1/5 sm:w-1/12 flex items-center justify-center'}>
                    <img className={'w-4/5'} src="img/info.png" alt="info"/>
                </div>
                <div className={'w-4/5 sm:w-11/12 font-normal'}>
                    Thông tin hóa đơn của bạn đã được gửi đi. Chúng tôi sẽ gửi hóa đơn cho bạn qua email vào ngày 10
                    hàng
                    tháng.
                </div>
            </div>
            {
                invoiceStatus === 'VERIFIED' && (
                    <div className={'flex p-3 mt-3 w-full bg-green-50'}>
                        <div className={'w-1/12 flex items-center justify-between'}>
                            <img className={'w-4/5'} src="img/check-green.png" alt="info"/>
                        </div>
                        <div className={'flex items-center justify-start w-10/12 font-normal font-bold'}>Thông tin đã được
                            xác thực
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default function Information() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const formData = useSelector(state => state.invoice.invoiceForm)
    const token = useSelector(state => state.app.token)
    const isAuthenticated = useSelector(state => state.app.isAuthenticated)
    const {isShowing, toggle} = useModal();
    let [searchParams] = useSearchParams();
    const status = searchParams.get("status")
    const formId = searchParams.get("formId")
    let dispatch = useDispatch()
    let footer
    let modalContent

    function toCompleted() {
        navigate({
            pathname: '/information?status=completed',
        })
    }

    function toggleLoading(status) {
        setIsLoading(status);
    }

    async function submitData() {
        try {
            toggle()
            toggleLoading(true)
            if (formData['id']) {
                let {data} = await updateInvoice({
                    invoiceId: formData['id'],
                    token,
                    formData: invoiceInfoInterface(formData, true)
                })
                dispatch(setInvoiceData({data}))
            } else {
                let {data} = await createInvoice({
                    token,
                    formData: invoiceInfoInterface(formData, true)
                })
                dispatch(setInvoiceData({data}))
            }
            toggleLoading(false)
            toCompleted()
        } catch {
            toggleLoading(false)
            toCompleted()
        }
    }

    async function confirmDelete() {
        try {
            toggle()
            toggleLoading(true)
            await deleteInvoice({
                token,
                invoiceId: formData['id']
            })
            await dispatch(clearForm())
            toggleLoading(false)
            navigate('/?status=modify')
        } catch {
            toggleLoading(false)
        }
    }

    useEffect(() => {
        if (!isAuthenticated) {
            return
        }

        async function getInfo(invoiceId) {
            try {
                setIsLoading(true)
                let data = await getInvoice({invoiceId})
                if (data) {
                    dispatch(setInvoiceData({data}))
                    setIsLoading(false)
                }
            } catch {
                setIsLoading(false)
            }
        }

        if (formId) {
            getInfo()
        }
    }, [])

    switch (status) {
        case 'confirm':
            footer = <ConfirmFooter openConfirm={toggle}/>
            modalContent = <ConfirmModal cancel={toggle} submit={submitData}/>
            break
        case 'completed':
            footer = <CompletedFooter openDelete={toggle}/>
            modalContent = <DeleteModal cancel={toggle} deleteInvoice={confirmDelete}/>
            break
        default:
            footer = (<div/>)
            break
    }
    return (
        <div className={'w-full h-screen bg-slate-100 flex flex-col items-center justify-start'}>
            <div className={'max-w-screen-lg static bg-white'}>
                <InformationHeader invoiceStatus={formData['status']}/>
                <div className={'w-full h-2.5 bg-slate-100'}/>
                <div className={'p-3 pb-0 font-normal my-2 mb-3 w-full'}>
                    Thông tin dưới đây sẽ được in trên hóa đơn gửi về mỗi tháng, vui lòng chỉnh sửa thông tin nếu có sự
                    thay
                    đổi nào khác.
                </div>
                {
                    formData['status'] === 'VERIFIED' && (
                        <div className={'px-3 hidden sm:flex'}>
                            <div className={'flex px-3 py-1 mt-3 w-full bg-green-50'}>
                                <div className={'w-1/12 sm:w-8 flex items-center justify-between'}>
                                    <img className={'w-4/5'} src="img/check-green.png" alt="info"/>
                                </div>
                                <div className={'flex items-center justify-start w-10/12 font-normal font-bold'}>Thông tin đã được
                                    xác thực
                                </div>
                            </div>
                        </div>
                    )
                }
                <div className={'sm:p-3 grid grid-cols-1 sm:gap-7 sm:grid-cols-2'}>
                    <div className={'px-3 sm:p-0'}>
                        <InformationList inputList={InvoiceInputList} formData={formData}/>
                    </div>
                    <div className={'px-3 sm:p-0'}>
                        <InfoItem label={'Ahamove Id'} key={'ahamoveId'}
                                  content={<AhamoveIdList parentId={formData['userAhamoveId']}
                                                          childIdList={formData['childAhamoveId']}/>}/>
                        <InfoItem label={'Yêu cầu bổ sung'} key={'additionalInput'}
                                  content={<AdditionalOption formData={formData}/>}/>
                    </div>
                    {footer}
                </div>
                <Modal
                    isShowing={isShowing}
                    hide={toggle}
                    modalContent={modalContent}
                    mobileFloating
                />
                <Loading isShowing={isLoading}/>
            </div>
        </div>
    )
}

